import { render } from "./Tabs.vue?vue&type=template&id=197d2e91"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=197d2e91&lang=css"
script.render = render

export default script